import type { MeResponse } from "@/features/auth/types";

/**
 * Classe de largeur maximale du conteneur de contenu, pilotée par le réglage
 * abonné/clinique `layout_width` (résolu dans `me.active_display_config`).
 *
 * - `full` (défaut) : pleine largeur (`max-w-none`).
 * - `centered` : contenu centré, plafonné à 1440 px.
 *
 * Appliquée aux conteneurs internes du shell (navbar, contenu, pied) pour un
 * cadrage cohérent — les barres colorées restent en pleine largeur, seul leur
 * contenu se centre.
 */
export const CENTERED_MAX_WIDTH = "max-w-[1440px]";

export function contentMaxWidthClass(me: MeResponse | null | undefined): string {
  return me?.active_display_config?.layout_width === "centered" ? CENTERED_MAX_WIDTH : "max-w-none";
}
